export { PageNotFoundComponent } from './page-not-found/page-not-found.component';
export { ConfirmationComponent } from './confirmation/confirmation.component';
export { ThankYouComponent } from './thank-you/thank-you.component';